import fi from './fi'
import Utils from '../Utils'

var fiMsg = {
  'agreements.title': 'Sopimukset',
  'agreements.error.mandatory': "Sinun on hyväksyttävä nämä sopimukset, jotta voit jatkaa Deeper-palvelujen käy" +
      "ttöä",
  'agreements.error.blank': "Tee valinta",
  'agreements.back': 'Takaisin',
  'agreements.agree': 'Hyväksyn',
  'agreements.decline': 'En hyväksy',
  'agreements.text.full': 'Koko sopimus'
}

Utils.addTerms(fiMsg, fi)

export default fiMsg



// WEBPACK FOOTER //
// ./src/lang/fiMsg.js